import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=d83b5070&scoped=true&"
import script from "./CheckBox.vue?vue&type=script&lang=js&"
export * from "./CheckBox.vue?vue&type=script&lang=js&"
import style0 from "./CheckBox.vue?vue&type=style&index=0&id=d83b5070&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83b5070",
  null
  
)

export default component.exports